import { ILocale } from 'cng-common/features/translations/models'
import { checkCache, readFromCache, saveToCache } from 'core/classes/cache/Cache'
import StorageKeys from 'core/classes/cache/StorageKeys'
import { callProcedure } from 'core/classes/helpers/callProcedure'

// for react component use import { useGetReferenceLocalesQuery } from 'core/store/service/referenceLocales'
export const getLocales = async (): Promise<ILocale[]> => {
  const needRefresh = checkCache(StorageKeys.locales)
  if (needRefresh) {
    const data = await callProcedure('spApp_getLocales')
    saveToCache(StorageKeys.locales, data, true)
    return data
  } else {
    return readFromCache(StorageKeys.locales)
  }
}
